import React, { useState } from "react";
import Dropzone from "./Dropzone";
import { Button } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  root: { display: "flex", flexWrap: "wrap", justifyContent: "center" },
  submit: { margin: theme.spacing(1) },
  dropzone: { flexBasis: "100%" }
}));

export default function Layout({ onSubmit }) {
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  return (
    <div className={classes.root}>
      <div className={classes.dropzone}>
        <Dropzone setFiles={setFiles} />
      </div>
      <Button
        variant={"contained"}
        color={"primary"}
        className={classes.submit}
        onClick={() => onSubmit(files[0])}
      >
        Submit
      </Button>
    </div>
  );
}
